import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { FaExclamationTriangle } from 'react-icons/fa';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render shows the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can customize logging here
    console.error('Unhandled UI error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Container className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
          <div className="text-center p-5 bg-white rounded shadow-sm">
            <FaExclamationTriangle className="text-danger mb-4" size={64} />
            <h2 className="mb-3">حدث خطأ غير متوقع</h2>
            <p className="text-muted mb-4">نعتذر عن هذا الخلل. حدث خطأ أثناء تحميل الصفحة.</p>
            <Button variant="primary" onClick={() => window.location.reload()}>
              تحديث الصفحة
            </Button>
          </div>
        </Container>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;
